import React from 'react';
import AboutInfoSection from './AboutInfoSection'; // Tái sử dụng component đã tạo

const GeneralIntro = () => {
    return (
        <div>
            {/* Bạn có thể thêm các section khác liên quan đến giới thiệu chung ở đây */}
            <AboutInfoSection />
        </div>
    );
};

export default GeneralIntro;